import { Component, Inject, OnInit, OnDestroy } from '@angular/core';

import {
    BookRideStops,
    GeocodeAddress,
    MapCoordinates,
    MapIcons,
    OnDemandTripsFacade,
    RidePlannerFacade
} from '@ridango/components';
import Env from '@ridango/core/env';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';

@Component({
    templateUrl: './ondemand-trips-page.component.html'
})
export class OndemandTripsPageComponent extends BaseComponent implements OnInit, OnDestroy {
    zoom = 13;
    mapCenter: MapCoordinates = this.env.MAP.COORDINATES;
    pickUp: BookRideStops;
    dropOff: BookRideStops;
    polyline: string;

    iconOrigin = MapIcons('pin');
    iconDestination = MapIcons('origin');
    iconStop = MapIcons('bus-stop');
    potentialStops$ = this.ridePlanner.potentialStops$;
    polyline$ = this.onDemand.polyline$;
    trip$ = this.onDemand.selectedTrip$;
    clickedStop: GeocodeAddress;
    isFullMap = false;
    polylineColor = 'var(--color-brand-primary)';

    constructor(
        @Inject('ENV') private env: Env,
        private ridePlanner: RidePlannerFacade,
        private onDemand: OnDemandTripsFacade
    ) {
        super();
    }

    ngOnInit(): void {
        this.trip$.pipe(takeUntil(this.componentDestroyed$)).subscribe((trip) => {
            if (trip?.stops.length > 1) {
                this.pickUp = trip.stops[0];
                this.dropOff = trip.stops[trip.stops.length - 1];
            } else {
                this.pickUp = null;
                this.dropOff = null;
            }
        });
    }

    onStopClicked(event): void {
        this.clickedStop = event;
    }

    toggleMapSize() {
        this.isFullMap = !this.isFullMap;
    }
}
